export default __webpack_public_path__ + "static/media/3124.7be102e0.jpg";